<template>
  <BaseListItem :class="[wasLastEdited ? 'bg-blue-200' : '']">
    <div class="flex -mx-3 p-4">
      <div class="w-24 px-3">
        <template v-if="account && account.logo">
          <img :src="account.logo" class="block rounded w-full" />
        </template>
        <template v-else>
          <div class="aspect-ratio-square w-full rounded bg-gray-200" />
        </template>
      </div>
      <div class="flex-1 px-3">
        <a role="button" @click="$emit('contact-edit', contact.id)">
          {{ contact.fullName }}
        </a>
        <div class="mt-1">
          <span
            v-if="typeof contact.unsubscribeRequestId === 'string'"
            class="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800"
            >{{ $t('global.unsubscribed') }}</span
          >
        </div>
        <div v-if="primaryEmailAddress" class="mt-1">
          <a v-if="primaryEmailAddress" :href="`mailto:${primaryEmailAddress.address}`">{{
            primaryEmailAddress.address
          }}</a>
          &bull;
          <a v-if="primaryPhoneNumber" :href="`tel:${primaryPhoneNumber.number}`"
            >{{ primaryPhoneNumber.number }}
          </a>
        </div>
      </div>
      <div class="flex-1 px-3">
        <p>
          <RouterLink
            v-if="project"
            :to="{
              name: 'accounts.projects.project',
              params: {
                accountId: contact.accountId,
                projectId: project.uuid,
              },
            }"
          >
            {{ project.name }}
          </RouterLink>
          <span v-else>-</span>
        </p>
        <p>
          <span v-if="pipelineStage">{{ pipelineStage.name }}</span>
          <span v-else>-</span>
        </p>
      </div>

      <div class="w-48 px-3 text-right">
        <p>
          {{ contact.createdAtDiffForHumans }}
        </p>
        <p class="text-sm text-gray-600">
          {{ contact.createdAt }}
        </p>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    contact: { type: Object, required: true },
  },

  computed: {
    ...mapState('entities', {
      project({ projects }) {
        if (!this.contact.projectUuid) return null;

        return projects.byId[this.contact.projectUuid];
      },
      campaign({ campaigns }) {
        if (!this.contact.campaignUuid) return null;

        return campaigns.byId[this.contact.campaignUuid];
      },
      pipelineStage({ pipelineStages }) {
        if (!this.contact.currentPipelineStageId) return null;

        return pipelineStages.byId[this.contact.currentPipelineStageId];
      },
      primaryEmailAddress({ emailAddresses }) {
        if (!this.contact.primaryEmailAddressId) return null;

        return emailAddresses.byId[this.contact.primaryEmailAddressId];
      },
      primaryPhoneNumber({ phoneNumbers }) {
        if (!this.contact.primaryPhoneNumberId) return null;

        return phoneNumbers.byId[this.contact.primaryPhoneNumberId];
      },
      account(state) {
        if (!this.contact.accountId) {
          return null;
        }

        return state.accounts.byId[this.contact.accountId] || null;
      },
    }),
    fullName() {
      if (!this.contact) return 'contact does not exist';
      return `${this.contact.firstName} ${this.contact.lastName}`;
    },
    hasValidPhoneFormat() {
      if (!this.contact || !this.contact.phone) return false;
      return /^\d{10}$/.test(this.contact.phone);
    },
    to() {
      return {
        name: 'accounts.contacts.show',
        params: { accountId: this.account.id, contactId: this.contact.id },
      };
    },
    wasLastEdited() {
      return this.contact.id === this.lastEditedContact;
    },
  },
};
</script>
